export class RouterError extends Error {
  type = 'RouterError';
  static NotInitialized() {
    return new RouterError('Router not initialized');
  }
  static EmptyURI() {
    return new RouterError('Can not navigate to empty uri');
  }
}
